import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog'; 

@Component({
  selector: 'app-map-popup',
  templateUrl: './map-popup.component.html',
  styleUrls: ['./map-popup.component.scss'],
})
export class MapPopupComponent {
  startDate: string = '';
  startTime: string = '';

  constructor(private dialogRef: MatDialogRef<MapPopupComponent>) {}

  submitDateTime(confirmed: boolean): void {
    const dateTimeData = {
      startDate: this.startDate,
      startTime: this.startTime,
    };

    if (confirmed) {
      this.dialogRef.close(dateTimeData);
    } else {
      this.dialogRef.close();
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
